@if (hasChoice()) {
    <p-select [options]="facilities()"
              optionLabel="name"
              optionValue="id"
              appendTo="body"
              styleClass="facility-select"
              ariaLabel="Facility"
              [(ngModel)]="selectedId" />
} @else if (selectedName()) {
    <span class="text-lg text-surface-500">{{ selectedName() }}</span>
} @else {
    <span class="text-lg text-surface-400 italic">No facility assigned</span>
}
